export const optionCardsData = [
  {
    id: "optionCard1",
    popular: false,
    title: "Frontend Only",
    name: "frontend",
    image: {
      url: "/order-now/icons/icon-package-frontend.svg",
      alt: "Front End work icon",
      width: 48,
      height: 48,
    },
    options: [
      {
        name: "Framework Options:",
        description: "Bootstrap, Tailwind, or none.",
      },
    ],
    description:
      "Pixel-perfect, W3C-compliant code that ensures your website looks and performs great.",
  },
  {
    id: "optionCard3",
    popular: true,
    title: "Elementor",
    subtitle: "Based WordPress Theme",
    name: "elementor",
    image: {
      url: "/order-now/icons/icon-package-elementor.svg",
      alt: "Elementor work icon",
      width: 48,
      height: 48,
    },
    options: [
      {
        name: "WordPress Builder:",
        description: "Elementor.",
      },
      {
        name: "Premium WordPress plugin licenses included for the first year:",
        items: ["Elementor Pro", "WP-Rocket"],
      },
    ],
    description:
      "A customized WordPress theme using Elementor's ready-made blocks to reflect your designs or style guide.",
  },
  {
    id: "optionCard2",
    popular: false,
    title: "Custom",
    subtitle: "WordPress Theme",
    name: "wordpress",
    image: {
      url: "/order-now/icons/icon-package-wordpress.svg",
      alt: "Wordpress work icon",
      width: 48,
      height: 48,
    },
    options: [
      {
        name: "WordPress Builder:",
        description: "ACF, Gutenberg, Elementor or Divi.",
      },
      {
        name: "Premium WordPress plugin licenses included for the first year:",
        items: ["Elementor Pro", "WP-Rocket"],
      },
    ],
    description:
      "A custom pixel-perfect WordPress theme with 100% adherence to your design.",
  },
];
